import React, { useEffect, useRef } from 'react';
import { Sparkles } from 'lucide-react';

const Step1Intro = ({ onNext }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(err => {
        console.log('Autoplay prevented:', err);
      });
    }
  }, []);

  return (
    <div className="step step-intro-new">
      <h1 className="intro-title-new">Explore AI Girlfriends</h1>
      
      <div className="intro-card">
        <div className="intro-video-container">
          <video
            ref={videoRef}
            src="https://cdn.lovescape.com/cdn/front/videos/marketing/intro123.mp4"
            autoPlay
            muted
            loop
            playsInline
            className="intro-video"
          />
        </div>
        
        <button 
          onClick={() => onNext({})}
          className="create-button-new"
        >
          <Sparkles size={20} />
          Create
        </button>
      </div>
    </div>
  );
};

export default Step1Intro;